// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Profile from "layouts/profile"; 
import Php from "layouts/php";
import Url from "layouts/url";
import Pro from "layouts/pro";
import Multipart from "layouts/Multipart";
import Comentarios from "layouts/comentarios";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";


const routes = [
  {
    type: "collapse",
    name: "Panel", 
    key: "Panel",
    route: "/Panel",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },


  {
    type: "collapse",
    name: "Multipart",
    key: "Multipart",
    route: "/Multipart",
    icon: <Shop size="12px" />,
    component: <Multipart />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Contacto",
    key: "Contacto",
    route: "/Contacto",
    icon: <Office size="12px" />,
    component: <Tables />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Codeflex Polly",
    key: "Polly",
    route: "/Polly",
    icon: <CreditCard size="12px" />,
    component: <Billing />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "phpMyAdmin",
    key: "phpMyAdmin",
    route: "/phpMyAdmin",
    icon: <Document size="12px" />,
    component: <Php />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Shorten URL",
    key: "Shorten-URL",
    route: "/Shorten-URL",
    icon: <Document size="12px" />,
    component: <Url />,
    noCollapse: true,
  },

  {
    name: "upgrade",
    key: "upgrade",
    route: "/upgrade",
    component: <Pro />,
    noCollapse: true,
  },
  { type: "title", title: "Cuenta", key: "account-pages" },
  {
    type: "collapse",
    name: "Perfil de usuario",
    key: "Perfil",
    route: "/Perfil",
    icon: <CustomerSupport size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Comentarios",
    key: "Comentarios",
    route: "/Comentarios",
    icon: <SpaceShip size="12px" />,
    component: <Comentarios />,
    noCollapse: true,
  },
];

export default routes;
